import React from 'react';
import illustration from '../../assets/illustrations/LandingPage/site de vendas V2-19.png';
import illustrationStar from '../../assets/illustrations/LandingPage/telas_site-14.png';

const DuvidasSection: React.FC = () => {
  return (
    <section className="relative w-full bg-[#d7cdbd] p-8 lg:p-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-stretch min-h-[400px]">
          {/* Coluna Esquerda */}
          <div className="relative z-20 flex flex-col items-center justify-evenly py-14 lg:py-20">
            <h2 className="text-6xl lg:text-7xl font-libre italic text-cafe">
              dúvidas?
            </h2>

            <div className=" w-fit mb-6 sm:mb-10 bg-[#1f5c57] rounded-full p-1">
              <a
                href="https://wa.me/5511973837444"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-[#1f5c57] border-[4px] border-[#d7cdbd] text-white py-4 rounded-full text-sm tracking-widest uppercase shadow-lg hover:scale-105 transition-all duration-300 w-fit border-2 border-[#3a7a75]"
              >
                <span className='text-2xl text-[#C29F80] px-4'> • {' '}</span>
                Chame no WhatsApp
                <span className='text-2xl text-[#C29F80] px-4'> • {' '}</span>
              </a>
            </div>
          </div>

          {/* Coluna Direita - Imagem placeholder */}
          <div className="relative z-20 flex items-stretch py-6 lg:py-10">
            <img
              src={illustrationStar}
              alt=""
              className=""
            />
          </div>
        </div>
      </div>

      {/* Ilustração decorativa - canto inferior esquerdo */}
      <img
        src={illustration}
        alt=""
        className="hidden lg:block absolute left-0 top-[350px] w-[150px]"
      />
    </section>
  );
};

export default DuvidasSection;
